var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 17.6C5.39 17.6 4.411 18.59 4.411 19.8C4.411 21.01 5.39 22 6.6 22C7.81 22 8.8 21.01 8.8 19.8C8.8 18.59 7.81 17.6 6.6 17.6ZM0 0V2.2H2.2L6.16 10.549L4.675 13.244C4.499 13.552 4.4 13.915 4.4 14.3C4.4 15.51 5.39 16.5 6.6 16.5H19.8V14.3H7.062C6.908 14.3 6.787 14.179 6.787 14.025L6.82 13.893L7.81 12.1H16.005C16.83 12.1 17.556 11.649 17.93 10.967L21.868 3.828C21.956 3.674 22 3.487 22 3.3C22 2.695 21.505 2.2 20.9 2.2H4.631L3.597 0H0ZM17.6 17.6C16.39 17.6 15.411 18.59 15.411 19.8C15.411 21.01 16.39 22 17.6 22C18.81 22 19.8 21.01 19.8 19.8C19.8 18.59 18.81 17.6 17.6 17.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.ffe71edc6afb790b73ab836168329bb8.svg";
export { ForwardRef as ReactComponent };